var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 1.33331C4.31203 1.33331 1.33203 4.31331 1.33203 7.99998C1.33203 11.6866 4.31203 14.6666 7.9987 14.6666C11.6854 14.6666 14.6654 11.6866 14.6654 7.99998C14.6654 4.31331 11.6854 1.33331 7.9987 1.33331ZM11.332 10.3933L10.392 11.3333L7.9987 8.93998L5.60536 11.3333L4.66536 10.3933L7.0587 7.99998L4.66536 5.60665L5.60536 4.66665L7.9987 7.05998L10.392 4.66665L11.332 5.60665L8.9387 7.99998L11.332 10.3933Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.89809e16b9b6a5e98259312898d534d9.svg";
export { ForwardRef as ReactComponent };